import React from 'react'
import Slider from 'react-slick'
import { DecorativeIcon } from '../../../../utils/spaarneIcons'
import { carouselBlockClasses } from '../../../../utils/style'
import { getClassName, slugify } from '../../../../utils/utils'
import { useInView } from '../../../hooks/useInView'
import { GridLinkItemLayout } from '../../../sharedLayout/gridItem'
import { CarouselBlock } from '../blocksState'

export type CarouselBlockStyle = Partial<{
  blockClassName: string
  blockWithHeaderClassName: string
  blockWithLinkClassName: string
  inviewClassName: string
  innerClassName: string
  headerClassName: string
  titleClassName: string
  introClassName: string
  contentClassName: string
  listClassName: string
}>

const NextArrow = (props: any) => {
  return (
    <button className={'carousel__arrow next--arrow'} style={{ ...props.style }} onClick={props.onClick} aria-label="Next slide">
      <DecorativeIcon iconId="icon--arrow" width="19px" height="19px" className="button__icon icon--desktop" />
      <DecorativeIcon iconId="icon--chevron-up" width="16px" height="16px" className="button__icon icon--mobile" />
    </button>
  )
}

const PrevArrow = (props: any) => {
  return (
    <button className={'carousel__arrow prev--arrow'} style={{ ...props.style }} onClick={props.onClick} aria-label="Previous slide">
      <DecorativeIcon iconId="icon--arrow" width="19px" height="19px" className="button__icon icon--desktop" />
      <DecorativeIcon iconId="icon--chevron-up" width="16px" height="16px" className="button__icon icon--mobile" />
    </button>
  )
}

const settings = {
  dots: false,
  centerMode: true,
  className: 'center',
  variableWidth: true,
  infinite: true,
  speed: 500,
  slidesToShow: 5,
  slidesToScroll: 3,
  swipeToSlide: true,
  rows: 1,
  nextArrow: <NextArrow />,
  prevArrow: <PrevArrow />,
  responsive: [
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        // swipeToSlide: true,
        // centerMode: true,
        // variableWidth: true,
      },
    },
  ],
}

export const CarouselBlockLayout = (props: CarouselBlock) => {
  const { index, inview, intro, title } = props
  let { items } = props

  if (items.length <= 2) return <></>
  else {
    if (items.length <= 5) {
      items = items.concat(items)
    }
  }

  const { inView, ref } = useInView(
    { threshold: 0.1 },
    (inview) => console.debug("CarouselBlockLayout inView:", inview),
    !inview?.triggerOnce
  )

  return (
    <section
      key={`block-${index}`}
      id={`io-${index}`}
      ref={ref}
      className={getClassName(carouselBlockClasses, 'blockClassName', 'container') + ' ' + (inView ? getClassName(carouselBlockClasses, 'inviewClassName', 'inview') : '')}
    >
      <div className={getClassName(carouselBlockClasses, 'innerClassName', 'py-5')}>
        {(title || intro) && (
          <header className={getClassName(carouselBlockClasses, 'headerClassName', '')}>
            {title && <h2 className={getClassName(carouselBlockClasses, 'titleClassName', 'mb-3')}>{title}</h2>}
            {intro && <p className={getClassName(carouselBlockClasses, 'introClassName', '')}>{intro}</p>}
          </header>
        )}
        {items.length > 0 && (
          <div className={getClassName(carouselBlockClasses, 'contentClassName', '')}>
            <Slider {...settings}>
              {items.map(
                (item) =>
                  item.link && (
                    <div className="grid__link-item grid__item">
                      <GridLinkItemLayout
                        title={item.title}
                        intro={item.intro}
                        url={item.link.url}
                        image={item.image}
                        key={`rc-${slugify(item.link.url)}`}
                      />
                    </div>
                  )
              )}
            </Slider>
          </div>
        )}
      </div>
    </section>
  )
}
